import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=6b405842&scoped=true&"
import script from "./fans.vue?vue&type=script&lang=js&"
export * from "./fans.vue?vue&type=script&lang=js&"
import style0 from "./fans.vue?vue&type=style&index=0&id=6b405842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b405842",
  null
  
)

export default component.exports